import React from 'react';

import CSSModules from 'react-css-modules';

import Heading from '../../TextComponents/Heading';
import {createMarkup} from '../../utils/markdownUtils';

import styles from './styles.module.scss';

type TextProps = {
  title?: string;
  titlePlaceholder?: string;
  description?: string;
  descriptionPlaceholder?: string;
};

const Text = ({
  title,
  titlePlaceholder,
  description,
  descriptionPlaceholder,
}: TextProps): JSX.Element => (
  <div>
    <div styleName='introTitle'>
      <Heading
        as='h3'
        size='cat'
        colour={title ? 'textPrimary' : 'grey300'}
        weight='medium'
        dataAutomation='component-title'
      >
        {title || titlePlaceholder || ''}
      </Heading>
    </div>
    <div
      styleName={!description ? 'placeholder' : ''}
      data-automation='component-description'
    >
      <div
        dangerouslySetInnerHTML={createMarkup(
          description || descriptionPlaceholder || ''
        )}
      />
    </div>
  </div>
);

export default CSSModules(Text, styles);
